import React from 'react';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import WorkspaceStatusChip from './WorkspaceStatusChip';
import { formatWorkspaceDate } from './workspaceViewModel';

const compactContext = (workspace) => workspace.requestTitle || workspace.capabilityName || 'No linked request';

export default function WorkspaceListView({ workspaces, onOpen }) {
  return (
    <TableContainer
      sx={(theme) => ({
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 3,
        bgcolor: 'background.paper',
        boxShadow: theme.shadows[1],
      })}
    >
      <Table size="small" sx={{ minWidth: 1050 }} aria-label="Workspaces list">
        <TableHead>
          <TableRow>
            <TableCell>Workspace</TableCell>
            <TableCell>Request / Capability</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Partner Scope</TableCell>
            <TableCell align="center">Runs</TableCell>
            <TableCell align="center">Artifacts</TableCell>
            <TableCell>Last Activity</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {workspaces.map((workspace) => (
            <TableRow key={workspace.id} hover>
              <TableCell sx={{ maxWidth: 260 }}>
                <Tooltip title={workspace.title} placement="top-start">
                  <Typography variant="body2" noWrap sx={{ fontWeight: 700 }}>
                    {workspace.title}
                  </Typography>
                </Tooltip>
                {workspace.description ? (
                  <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
                    {workspace.description}
                  </Typography>
                ) : null}
              </TableCell>
              <TableCell sx={{ maxWidth: 260 }}>
                <Tooltip title={compactContext(workspace)} placement="top-start">
                  <Typography variant="body2" noWrap>{compactContext(workspace)}</Typography>
                </Tooltip>
                {workspace.requestTitle && workspace.capabilityName ? (
                  <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
                    {workspace.capabilityName}
                  </Typography>
                ) : null}
              </TableCell>
              <TableCell><WorkspaceStatusChip status={workspace.status} /></TableCell>
              <TableCell sx={{ maxWidth: 190 }}>
                <Typography variant="body2" noWrap>
                  {[workspace.partnerScopeName, workspace.partnerScopeCode].filter(Boolean).join(' · ') || 'Not available'}
                </Typography>
              </TableCell>
              <TableCell align="center">
                {workspace.activeRunsCount > 0 ? (
                  <Chip size="small" color="info" label={`${workspace.activeRunsCount} active`} />
                ) : workspace.runsCount}
              </TableCell>
              <TableCell align="center">{workspace.artifactsCount}</TableCell>
              <TableCell>
                <Typography variant="body2" noWrap>{formatWorkspaceDate(workspace.updatedAt)}</Typography>
              </TableCell>
              <TableCell align="right">
                <Button
                  size="small"
                  endIcon={<ArrowForwardRoundedIcon />}
                  onClick={() => onOpen(workspace)}
                  aria-label={`Open ${workspace.title}`}
                >
                  Open
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
